import React, { useState, useEffect } from 'react';
import { makeStyles, InputBase, Button, Box, CircularProgress } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';

import { useDispatch, useSelector } from 'react-redux';
import { setFiles } from 'app/store/slices/forms';

import styles from './styles';
const useStyles = makeStyles(styles);

function FileField(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const files = useSelector(state => state.forms.files);

  const { field, label, id, required, error } = props;

  const [fileValue, setFileValue] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    files.forEach(file => {
      if (file.fieldname === `file-${field.name}`) {
        setFileValue(file);
      }
    });
  }, [field.name, files]);

  const onChange = ({ target: { name, files } }) => {
    if(files[0]){
      setLoading(true);
      const reader = new FileReader();
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        const fileContent = {
          fieldname: `file-${field.name}`,
          name: files[0].name,
          size: files[0].size,
          type: files[0].type,
          lastModified: files[0].lastModified,
          webkitRelativePath: files[0].webkitRelativePath,
          file: reader.result,
        };
        setFileValue(fileContent);
        dispatch(setFiles([fileContent]));
        setLoading(false);
      };
      reader.readAsDataURL(files[0]);
    }
  };

  return (
    <div className={classes.field}>
      <input
        id={id}
        name={`file-${field.name}`}
        onChange={onChange}
        type="file"
        style={{ display: 'none' }}
      />

      <div className={classes.root}>
        <>
          <label htmlFor={id}>
            <Button className={classes.btnCarregar} component="span" variant="outlined">
              <PublishIcon className={classes.icon} /> {label} {required ? '*' : ''}
            </Button>
          </label>
          <InputBase value={fileValue.name ? fileValue.name : ' '} />
          {loading && <CircularProgress size={11} />}
        </>
      </div>
      {error && (
        <Box className={classes.error} color="error.main">
          Campo obrigatório
        </Box>
      )}
    </div>
  );
}

export default FileField;
